module.exports = "/images/bg.jpg?00cdd9b3d5fc6c12029a72b796a2a151";